import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomepageComponent } from './views/homepage/homepage.component';
import { SignupComponent } from './views/signup/signup.component';
import { DossierComponent } from './views/dossier/dossier.component';
import { CouponComponent } from './views/coupon/coupon.component';
import { DossierAddComponent } from './views/dossier-add/dossier-add.component';
import { DossierPostComponent } from './views/dossier-post/dossier-post.component';
import { IsSignedInGuard } from './guard/is-signed-in.guard';
import { TarifsComponent } from './views/tarifs/tarifs.component';
import { HistoryComponent } from './views/history/history.component';
import { CommentCaMarcheComponent } from './views/comment-ca-marche/comment-ca-marche.component';
import { QuiSommesNousComponent } from './views/qui-sommes-nous/qui-sommes-nous.component';
import { SecuriteDonneesComponent } from './views/securite-donnees/securite-donnees.component';
import { NousContacterComponent } from './views/nous-contacter/nous-contacter.component';
import { DossierDelegationComponent } from './views/dossier-delegation/dossier-delegation.component';

const routes: Routes = [
	{path: '', redirectTo: 'homepage', pathMatch: 'full'},
  {path: 'homepage', component: HomepageComponent},
  {path: 'signup', component: SignupComponent},
  {path: 'essai_gratuit', component: SignupComponent},
  {path: 'tarifs', component: TarifsComponent},
  {path: 'bulletin-salaire-convention-collective-comment-ca-marche', component: CommentCaMarcheComponent},
  {path: 'paie-diagnostic-simulation-convention-collective-qui-sommes-nous', component: QuiSommesNousComponent},
  {path: 'securite-anonymisation-donnees', component: SecuriteDonneesComponent},
  {path: 'nous-contacter', component: NousContacterComponent},
  {path: 'history', component: HistoryComponent, canActivate: [
    IsSignedInGuard
  ]},
  {path: 'dossier', component: DossierComponent, canActivate: [
    IsSignedInGuard
  ]},
  {path: 'dossier/archive', component: DossierComponent, canActivate: [
    IsSignedInGuard
  ]},
  {path: 'coupon', component: CouponComponent, canActivate: [
    IsSignedInGuard
  ]},
  //{path: 'dossier/add/:duplicate/:displayID', component: DossierAddComponent, canActivate: [
  //  IsSignedInGuard
  //]},
  {path: "dossier/delegation/:token", component: DossierDelegationComponent},
  {path: 'dossier/post/:displayID', component: DossierPostComponent, canActivate: [
    IsSignedInGuard
  ]},
	{path: ':action/:login/:id',component:HomepageComponent},
	{path: '**', redirectTo: 'homepage', pathMatch: 'full'},

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
